import useAuthenticatedWebsocket from 'hooks/useAuthenticatedWebSocket';

export default function WSConnector() {
  useAuthenticatedWebsocket();
}
